const supportPageLinks = {
  easybib: 'https://www.chegg.com/contactus/easybibsupport',
  chegg: '//www.chegg.com/contactus/',
  citationmachine: 'https://www.chegg.com/contactus/citationmachinesupport',
  citethisforme: 'https://www.chegg.com/contactus/citethisformesupport',
  bibme: 'https://www.chegg.com/contactus/bibmesupport',
}

module.exports = {
  supportPageLinks,
}
